import React, { useEffect, useState } from 'react';
import useModalStore from '../StatesStore/ModalStore';
import { Modal } from 'react-bootstrap';

import { collection, doc, getDocs, getDoc, where, query } from 'firebase/firestore';
import { db } from '../FirebaseConfig';
import ProfilePicture from '../UserProfile/ProfilePicture';
import { Link, useNavigate } from 'react-router-dom';

function FollowingModal() {
    const { closeModal, data } = useModalStore();
    const [followings, setFollowings] = useState([]);
    const [filteredfollowings, setFilteredfollowings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchfollowings = async () => {
            try {
                // Get the following subcollection for the current user
                const followingRef = collection(db, 'users', data?.uid, 'following');
                const q = query(followingRef, where("type", "==", "user"));
                const followingSnapshot = await getDocs(q);

                // Get user data for each following
                const followingsData = await Promise.all(
                    followingSnapshot.docs.map(async (user) => {
                        const userRef = doc(db, 'users', user.id);
                        const userSnap = await getDoc(userRef);
                        return {
                            uid: user.id,
                            ...userSnap.data()
                        };
                    })
                );

                setFollowings(followingsData);
                setFilteredfollowings(followingsData);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching followings:", error);
                setLoading(false);
            }
        };

        if (data?.uid) {
            fetchfollowings();
        }
    }, [data?.uid]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredfollowings(followings);
        } else {
            const filtered = followings.filter(following =>
                following.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                following.userTitle?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredfollowings(filtered);
        }
    }, [searchTerm, followings]);
    const handleProfileClick = (following) => {
        closeModal();
        navigate(following?.cover
            ? `/BrandHome/${following.uid}`
            : `/userProfile/${following.uid}`
        );
    };
    return (
        <>
            <style jsx>
                {`
                    .primaryModal .modal-content {
                        border-radius: 1.25rem !important;
                        overflow: hidden;
                        max-height: 80vh; /* Set maximum height relative to viewport */
                    }
                    
                    .primaryModal .modal-dialog {
                        // max-width: 92vw;
                        margin: 1rem auto; /* Add some margin */
                    }
                    
                    .modal-backdrop {
                        z-index: 1060 !important;
                    }
                    
                    .search-input {
                        width: 100%;
                        padding: 0.5rem 1rem;
                        border: 1px solid #C3C3C3;
                        border-radius: 8px;
                        
                    }
                    
                    .following-item {
                        display: flex;
                        align-items: center;
                        padding: 0.4rem 0;
                    }
                    
                    .followings-list {
                        max-height: calc(80vh - 200px); 
                        overflow-y: auto;
                        padding-right: 0.5rem; 
                    }
                    
                    /* Custom scrollbar styling */
                    .followings-list::-webkit-scrollbar {
                        width: 6px;
                    }
                    
                    .followings-list::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 10px;
                    }
                    
                    .followings-list::-webkit-scrollbar-thumb {
                        background: #888;
                        border-radius: 10px;
                    }
                    
                    .followings-list::-webkit-scrollbar-thumb:hover {
                        background: #555;
                    }
                `}
            </style>
            <Modal
                show
                onHide={closeModal}
                centered
                className="primaryModal"
            >
                <Modal.Body style={{ padding: "2.1rem " }}>
                    <div className="d-flex flex-column mb-0">
                        <div className="d-flex w-100 justify-content-between">
                            <div style={{
                                fontFamily: 'Inter',
                                color: "#101828",
                                fontWeight: 600,
                                fontSize: '20px',
                                paddingBottom: '1rem'
                            }}>
                                Following
                            </div>
                            <button
                                type="button"
                                style={{
                                    boxSizing: "border-box",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "1.688rem",
                                    height: "1.688rem",
                                    background: "#FFFFFF",
                                    border: "1px solid #FF3B30",
                                    boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                                    borderRadius: "25px",
                                    flex: "none",
                                    order: "1",
                                    flexGrow: "0",
                                }}
                                onClick={closeModal}
                            >
                                <svg
                                    style={{ width: "11px" }}
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13 1L1 13M1 1L13 13"
                                        stroke="#FF3B30"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                        {followings.length >= 6 && (
                            <input
                                type="text"
                                className="search-input mb-3"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        )}
                    </div>

                    <div className="followings-list">
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
                        ) : filteredfollowings.length > 0 ? (
                            filteredfollowings.map((following) => (
                                <div key={following.uid} className="following-item" onClick={() => handleProfileClick(following)}>
                                    <div className="avatar-xs me-2 mb-0" style={{ cursor: 'pointer' }}>

                                        <ProfilePicture userData={following} avatarSize={42} />

                                    </div>
                                    <div>
                                        <div className="following-name" style={{
                                            fontFamily: 'Inter',
                                            color: "#000000",
                                            fontWeight: 600,
                                            fontSize: '16px',
                                            lineHeight: '1.3',
                                            cursor: 'pointer'
                                        }}>
                                            {following.userName || 'Unknown User'}
                                        </div>
                                        <div className="following-bio" style={{
                                            fontFamily: 'Inter',
                                            color: "#676A79",
                                            fontWeight: 400,
                                            fontSize: '12px',
                                            lineHeight: '1.3',
                                            cursor: 'pointer'
                                        }}>
                                            {following.userTitle || 'No bio available'}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                {searchTerm ? 'No matching followings found' : 'No followings found'}
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default FollowingModal